import { render } from "./ConfirmacionSection.vue?vue&type=template&id=5856c396&ts=true"
import script from "./ConfirmacionSection.vue?vue&type=script&lang=ts"
export * from "./ConfirmacionSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__